import { render, staticRenderFns } from "./storelist.vue?vue&type=template&id=1b2d08da&scoped=true"
import script from "./storelist.vue?vue&type=script&lang=js"
export * from "./storelist.vue?vue&type=script&lang=js"
import style0 from "./storelist.vue?vue&type=style&index=0&id=1b2d08da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d08da",
  null
  
)

export default component.exports